import React from 'react'
import PropTypes from 'prop-types'

import { App, Header, Sidebar, Content, PageWrapper, AICatalystSubHeader } from 'views/layouts'
import { AICatalystWrapper } from 'views/containers'
import { Container } from 'views/components'

function RegulatoryChat() {
  return (
    <App>
      <Sidebar />
      <Header subHeader={<AICatalystSubHeader />} pageTitle="AI Catalyst" />

      <Content>
        <PageWrapper>
          <Container>
            <AICatalystWrapper model="regulatory_chat" />
          </Container>
        </PageWrapper>
      </Content>
    </App>
  )
}

// Default Props
RegulatoryChat.defaultProps = {
  actions: {},
  filters: {},
  ui: {},
}

// Proptypes Validation
RegulatoryChat.propTypes = {
  actions: PropTypes.shape({
    setShowHeaderLoader: PropTypes.func,
    setIsPageTableUpdated: PropTypes.func,
    showAlert: PropTypes.func,
  }),
  filters: PropTypes.shape({
    whitelistingFilters: PropTypes.instanceOf(Object),
  }),
  ui: PropTypes.shape({
    isPageTableUpdated: PropTypes.bool,
  }),
}

export default RegulatoryChat
